// extracted by mini-css-extract-plugin
export default {"section":"Privacy_section__vGqM9","title":"Privacy_title__HYb-X","textBlock":"Privacy_textBlock__DzIy3","text":"Privacy_text__ZOPtt"};